import html2canvas from "html2canvas"
import jsPDF from "jspdf"

export const onDownloadReportPdf = async (
  setLoading,
  reportRef,
  fileName = "Seo_Report"
) => {
  if (!reportRef.current) return

  setLoading(true)

  const pages = reportRef.current.querySelectorAll(".report-page")

  const pdf = new jsPDF("p", "mm", "a4")
  const pdfWidth = pdf.internal.pageSize.getWidth()
  const pdfHeight = pdf.internal.pageSize.getHeight()

  for (let i = 0; i < pages.length; i++) {
    const page = pages[i]

    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    })

    const imgData = canvas.toDataURL("image/png")
    const imgWidth = pdfWidth
    const imgHeight = (canvas.height * imgWidth) / canvas.width

    if (i !== 0) pdf.addPage()

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      imgWidth,
      Math.min(imgHeight, pdfHeight)
    )
  }

  pdf.save(`${fileName}.pdf`)
  setLoading(false)
}









// Centered

// import html2canvas from "html2canvas"
// import jsPDF from "jspdf"

// export const onDownloadReportPdf = async (
//     setLoading,
//     reportRef,
//     fileName = "Seo_Report"
// ) => {
//     if (!reportRef.current) return

//     setLoading(true)

//     const pages = reportRef.current.querySelectorAll(".report-page")

//     const pdf = new jsPDF("p", "mm", "a4")
//     const pdfWidth = pdf.internal.pageSize.getWidth()
//     const pdfHeight = pdf.internal.pageSize.getHeight()

//     for (let i = 0; i < pages.length; i++) {
//         const page = pages[i]

//         const canvas = await html2canvas(page, {
//             scale: 2,
//             useCORS: true,
//             backgroundColor: "#fff",
//         })

//         const imgData = canvas.toDataURL("image/png")

//         const imgWidth = pdfWidth
//         const imgHeight = (canvas.height * imgWidth) / canvas.width

//         // ✅ CENTER CONTENT VERTICALLY
//         const yOffset =
//             imgHeight < pdfHeight ? (pdfHeight - imgHeight) / 2 : 0

//         if (i !== 0) pdf.addPage()

//         pdf.addImage(
//             imgData,
//             "PNG",
//             0,
//             yOffset,
//             imgWidth,
//             Math.min(imgHeight, pdfHeight),
//         )
//     }

//     pdf.save(`${fileName}.pdf`)
//     setLoading(false)
// }





